export const BASE_URL = "https://nodepune-flashloan.mobiloitte.com/api/v1";